import script from "./Fastbooking.vue?vue&type=script&setup=true&lang=js"
export * from "./Fastbooking.vue?vue&type=script&setup=true&lang=js"

import "./Fastbooking.vue?vue&type=style&index=0&id=9a6c4094&scoped=true&lang=scss"
import "./Fastbooking.vue?vue&type=style&index=1&id=9a6c4094&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a6c4094"]])

export default __exports__